/// <amd-module name="Feed/Legacy/Components/PackageRetentionMessage" />
import * as React from "react";

import { FormatComponent } from "VSS/Platform/Components/Format";
import { IVssPageContext } from "VSS/Platform/Context";

import { Link } from "VSSUI/Link";
import { IMessageBarProps, MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";

import { CiConstants } from "Feed/Common/Constants/Constants";
import * as PackageResources from "Feed/Common/Resources";
import * as Actions from "Feed/Legacy/Actions/Actions";
import { SettingsActions } from "Feed/Legacy/Actions/SettingsActions";
import { CustomerIntelligenceHelper } from "Feed/Legacy/Helpers/CustomerIntelligenceHelper";
import { Retention } from "Feed/PackageDetails/Util/Retention";

/**
 * Props for PackageRetentionMessage
 */
export interface IPackageRetentionMessageProps extends IMessageBarProps {
    pageContext: IVssPageContext;

    /**
     * Package Id (Guid)
     */
    packageId: string;

    /**
     * The number (count) of versions in the package
     */
    versionCount: number;

    /**
     * If packageversion count matches display criteria
     */
    shouldDisplayRetention: boolean;
}

/**
 * Displays a message if the number of versions for the specified package is
 * approaching the retention limit
 */
export class PackageRetentionMessage extends React.Component<IPackageRetentionMessageProps, {}> {
    /** Has the control been shown to the user? */
    private shown = false;

    // tslint:disable-next-line:no-any
    constructor(props?: IPackageRetentionMessageProps, context?: any) {
        super(props, context);
    }

    get messageBarType(): MessageBarSeverity {
        return Retention.isVeryCloseToLimit(this.props.versionCount)
            ? MessageBarSeverity.Error
            : MessageBarSeverity.Warning;
    }

    get messageBarTextTemplate() {
        return Retention.isVeryCloseToLimit(this.props.versionCount)
            ? PackageResources.PackageRetention_CloseToLimitStrongWarning
            : PackageResources.PackageRetention_CloseToLimitWarning;
    }

    public render(): JSX.Element {
        return (
            this.props.shouldDisplayRetention &&
            this.publishControlShownCI() && (
                <MessageBar {...this.props} severity={this.messageBarType} onDismiss={this.onDismissMessage}>
                    <FormatComponent format={this.messageBarTextTemplate}>
                        {Retention.VERSION_LIMIT}
                        <Link href="#" onClick={this.onClick}>
                            {PackageResources.PackageRetention_ConfigureRetentionPolicies}
                        </Link>
                    </FormatComponent>
                </MessageBar>
            )
        );
    }

    private publishControlShownCI(): boolean {
        // We only want to publish the CI event once (when the control is first shown)
        if (!this.shown) {
            this.shown = true;
            this.publishCIMessage("Showed");
        }

        return true;
    }

    private onClick = event => {
        // Note: we're choosing to not handle Ctrl/Meta click here - insufficient value for a seldom shown control
        event.preventDefault();
        this.navigateToFeedSettings();
    };

    private onDismissMessage = () => {
        this.publishCIMessage("Closed");
        Actions.DismissPackageRetentionMessage.invoke(this.props.packageId);
    };

    private navigateToFeedSettings() {
        SettingsActions.FeedSettingsNavigateClicked.invoke({});
    }

    private publishCIMessage(action: string): boolean {
        CustomerIntelligenceHelper.publishEvent(this.props.pageContext, CiConstants.VersionLimitBanner, {
            Action: action,
            Severity: this.messageBarType === MessageBarSeverity.Warning ? "Info" : "Warning"
        });

        return true;
    }
}
